export default {
  data() {
    return {
      aboutTop: [
        {
          path: "/about/",
          name: "会社情報トップ",
        },
      ],
      aboutMenus: [
        {
          path: "/about/mission/",
          name: "企業理念",
        },
        {
          path: "/about/overview/",
          name: "会社概要",
        },
        {
          path: "/about/management/",
          name: "役員紹介",
        },
        {
          path: "/about/office/",
          name: "支店一覧",
        },
        {
          path: "/about/compliance/",
          name: "コンプライアンスへの取り組み",
        },
      ],
    };
  },
};
